
import { FormMessagePattern } from "./FormMessagePatternEnum";
import { FormMessageTarget } from "./FormMessageTargetEnum";

import { FormMessageScope } from "./FormMessageScope";
import { MessageConfig } from "./MessageConfig";

export function FormMessageDirective($timeout: angular.ITimeoutService, messageConfig: MessageConfig, $compile: angular.ICompileService): ng.IDirective {
    return {
        template: require("./form-message.template.html"),
        require: ["^formMessage"],
        controller: [function () {
            let ctrl = this;

            ctrl.$onInit = function () {
                ctrl.viewValue = {}
            }

            ctrl.defaultPattern = FormMessagePattern.ALL;
        }],
        compile: function () {

            let _template = require("./form-message.template.html").default;

            return function linkFn(scope: FormMessageScope, elements: any, attributes: angular.IAttributes, ctrls: Array<angular.IController>) {

                let selfCtrl = ctrls[0];

                // 检查必要参数
                if (!attributes.formName) {
                    throw new Error("");
                }

                if (!scope._validateResults) {
                    scope._validateResults = [];
                }

                // 错误信息列表
                scope._errorMessage = scope._errorMessage ? scope._errorMessage : messageConfig.messageLib;

                let targetItem = scope.$eval(attributes.items) || FormMessageTarget.ALL;

                // 通过关联的表单名称获取表单数据
                let formCtrl = scope.$eval(attributes.formName);
                // 错误显示模式
                selfCtrl.viewValue.pattern = scope.$eval(attributes.pattern) || selfCtrl.defaultPattern;

                let _targetItem = angular.isString(targetItem) ? targetItem : FormMessageTarget.ALL;

                scope.msgTargetArray = _targetItem.split(",");
                scope.__formCtrl = formCtrl;

                // 选取$error提取策略
                // let errorStrategy;

                // 提取$error生成验证结果列表
                // _targetItem.split(",").forEach((itemName) => {
                //     if (itemName === FormMessageTarget.ALL) {
                //         errorStrategy = new AllErrorStrategy();
                //     } else {
                //         errorStrategy = new ItemErrorStrategy();
                //     }

                //     let validateResult = errorStrategy.getError(itemName, formCtrl);

                //     if(validateResult){
                //         scope._validateResults.push(validateResult);
                //     }
                // })

                elements.html(_template);

                $compile(elements.contents())(scope);
            }
        }
    }
}

FormMessageDirective.$inject = ["$timeout", "messageConfig", "$compile"];